import React from 'react';
import { SdgTileData } from '../../types';

type SdgTileProps = SdgTileData & {
  showTileTitle?: boolean
};

const SdgTile = ({
  region,
  budget,
  duration,
  sdgFocus,
  mainFocusText = '',
  sdgTileTitle = '',
  showTileTitle = false,
  isDetailPage
}: SdgTileProps): JSX.Element => {
  // headline level in overview -> H4 | in Detailpage -> H3
  const headingLevel = (isDetailPage) ? '3' : '4';
  const HeadlineTagOutput = `h${headingLevel}` as keyof JSX.IntrinsicElements;

  return (
    <>
      {showTileTitle ? <HeadlineTagOutput className="hl-5">{sdgTileTitle}</HeadlineTagOutput> : null}
      <ul className="sdg-tile-container--icons-small">
        {region ? (
          <li>
            <span className="ic-location" aria-hidden="true" />
            <span>{region}</span>
          </li>
        ) : (
          ''
        )}
        {budget ? (
          <li>
            <span className="ic-foerderprodukte" aria-hidden="true" />
            <span>{budget}</span>
          </li>
        ) : (
          ''
        )}
        {duration ? (
          <li>
            <span className="ic-save-later" aria-hidden="true" />
            <span>{duration}</span>
          </li>
        ) : (
          ''
        )}
      </ul>
      <HeadlineTagOutput className="hl-5">{mainFocusText}</HeadlineTagOutput>
      <ul className="sdg-tile-container--icons-medium">
        {sdgFocus.map(({ icon, number, title }) => (
          <li key={number}>
            <img src={icon} width="26" height="26" aria-hidden="true" alt="" />
            <span>{number}</span>
            <span>{title}</span>
          </li>
        ))}
      </ul>
    </>
  );
};

export default SdgTile;
